import mixpanelEvents from 'constants/mixpanel';
import { ROUTES_PATH } from 'constants/routeConfig';
import Link from 'next/link';
import { trackMixpanel } from 'utils/mixpanel';

const SignUpDisclaimer = () => {
  return (
    <div className='tw-absolute tw-bottom-0 tw-pb-14 2xl_custom:tw-pb-9 tw-bg-white tw-w-[calc(100%-96px)]'>
      <div className='tw-text-TEXT_SECONDARY f-12-300 tw-mt-9' data-testid='sign-up-disclaimer'>
        By clicking “Create Account”, I agree to Zamp’s
        <Link href={ROUTES_PATH.TERMS_OF_USE} target='_blank' className='tw-mx-1 tw-underline  tw-underline-offset-2'>
          Terms of Use
        </Link>
        and
        <Link href={ROUTES_PATH.PRIVACY_POLICY} target='_blank' className='tw-mx-1 tw-underline tw-underline-offset-2'>
          Privacy Policy
        </Link>
      </div>

      <div className='tw-w-full tw-flex tw-justify-between tw-items-end tw-relative tw-text-TEXT_SECONDARY tw-pt-4 tw-bg-white'>
        <div className='tw-flex tw-items-center'>
          <div className='f-12-300' data-testid='sign-up-disclaimer-login-title'>
            Already have an account ?
          </div>
          <div
            role='presentation'
            onClick={() => trackMixpanel(mixpanelEvents.LOGIN_CLICK, {})}
            data-testid='sign-up-disclaimer-login-button'
          >
            <Link className='f-16-500 tw-cursor-pointer tw-text-ZAMP_PRIMARY tw-ml-2' href={ROUTES_PATH.LOGIN}>
              Log In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpDisclaimer;
